import React from "react"
import styled from "styled-components"

import { LoadingSpinnerPropsType } from "./LoadingSpinner.types"
import { getPrimaryColor, getPrimaryColorOpacity10 } from "../../../style/utils"
import { styleTheme } from "../../../style/theme";


const Component: React.FC<LoadingSpinnerPropsType> = (props) => (
  <div className={props.className} data-color={props.color}></div>
)

export const LoadingSpinner = styled(Component)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 4px solid ${getPrimaryColorOpacity10};
  border-radius: 50%;
  border-top: 4px solid ${getPrimaryColor};
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;

  &[data-color="teal"] {
    border: 4px solid ${styleTheme.colors.teal.light};
    border-top: 4px solid ${styleTheme.colors.teal.base};
  }

  &[data-color="pink"] {
    border: 4px solid ${styleTheme.colors.pink.light};
    border-top: 4px solid ${styleTheme.colors.pink.base};
  }

  &[data-color="orange"] {
    border: 4px solid ${styleTheme.colors.orange.light};
    border-top: 4px solid ${styleTheme.colors.orange.base};
  }

  &[data-color="green"] {
    border: 4px solid ${styleTheme.colors.green.light};
    border-top: 4px solid ${styleTheme.colors.green.base};
  }

  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
`;
